import { render, staticRenderFns } from "./PvChart.vue?vue&type=template&id=be167164&scoped=true"
import script from "./PvChart.vue?vue&type=script&lang=js"
export * from "./PvChart.vue?vue&type=script&lang=js"
import style0 from "./PvChart.vue?vue&type=style&index=0&id=be167164&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be167164",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be167164')) {
      api.createRecord('be167164', component.options)
    } else {
      api.reload('be167164', component.options)
    }
    module.hot.accept("./PvChart.vue?vue&type=template&id=be167164&scoped=true", function () {
      api.rerender('be167164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/PvChart.vue"
export default component.exports